import { Product } from "./state";

export enum ConditionTypes {
  MALARIA_CONSULTATION = "Malaria Prophylaxis",
  ALTITUDE_CONSULTATION = "Altitude Sickness",
  INSOMNIA_CONSULTATION = "Insomnia",
  MOTION_CONSULTATION = "Motion Sickness",
  DIARRHEA_CONSULTATION = "Traveler's Diarrhea",
  NAUSEA_CONSULTATION = "Nausea Prevention",
  URINARY_TRACT_INFECTION = "Urinary Tract Infection",
  VAGINAL_YEAST_INFECTION = "Vaginal Yeast Infection",
  TYPHOID_FEVER = "Typhoid Fever",
  SKIN_INFECTION = "Skin Infection",
  ANAPHYLAXIS = "Anaphylaxis",
  LYME_DISEASE_CONSULTATION = "Lyme Disease",
  INFLUENZA_CONSULTATION = "Influenza",
  RUNWAY_PLUS = "Runway Consultation",
}

export type ConditionType =
  | "travelerDiarrhea"
  | "malariaProphylaxis"
  | "altitudeSickness"
  | "motionSickness"
  | "nauseaPrevention"
  | "sleeplessness"
  | "yeastInfection"
  | "urinaryTractInfection"
  | "vivotif"
  | "skinInfection"
  | "anaphylaxis"
  | "lymeDisease"
  | "influenza"
  | "plus";

export const conditionTypeIndex: Map<ConditionTypes, ConditionType> = new Map<
  ConditionTypes,
  ConditionType
>([
  [ConditionTypes.DIARRHEA_CONSULTATION, "travelerDiarrhea"],
  [ConditionTypes.MOTION_CONSULTATION, "motionSickness"],
  [ConditionTypes.ALTITUDE_CONSULTATION, "altitudeSickness"],
  [ConditionTypes.INSOMNIA_CONSULTATION, "sleeplessness"],
  [ConditionTypes.MALARIA_CONSULTATION, "malariaProphylaxis"],
  [ConditionTypes.NAUSEA_CONSULTATION, "nauseaPrevention"],
  [ConditionTypes.URINARY_TRACT_INFECTION, "urinaryTractInfection"],
  [ConditionTypes.VAGINAL_YEAST_INFECTION, "yeastInfection"],
  [ConditionTypes.TYPHOID_FEVER, "vivotif"],
  [ConditionTypes.SKIN_INFECTION, "skinInfection"],
  [ConditionTypes.ANAPHYLAXIS, "anaphylaxis"],
  [ConditionTypes.LYME_DISEASE_CONSULTATION, "lymeDisease"],
  [ConditionTypes.INFLUENZA_CONSULTATION, "influenza"],
]);

export interface Medication {
  // TODO: Apply Medication Catalog Refactor.
  /**
   * id = MDI_ID (telehealth vendor ID, not a Stripe ID)
   * price_id = Stripe Price ID (price_*), set by the server at medication resolution time
   */
  id?: string;
  price_id?: string;
  name?: string;
  quantity: number;
  metadata?: Record<string, string>;
}
export interface Condition {
  product: Product;
  suggestedMedication?: Medication;
  price?: number;
}

export interface MedicationUpsellConditionConfig {
  allowMultipleMedicationSelection: boolean;
  promotedMedications: string[];
  suppressSeeOptionsWhenCartPreselects: string[];
}

export interface MedicationUpsellConfig {
  conditions: Record<string, MedicationUpsellConditionConfig>;
}
